import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { SERVICE_AREAS } from "../../lib/content";
import { Eyebrow } from "../Reveal";

export const ServiceAreas = () => (
  <section id="areas" data-testid="service-areas" className="bg-background py-24 md:py-32 border-t border-border">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-5">
          <Eyebrow>Where we serve</Eyebrow>
          <h2 className="font-display text-5xl md:text-7xl font-light tracking-tight leading-[0.95] mt-4 mb-6">
            Coast to coast,
            <br />
            <span className="text-primary italic">wherever you gather.</span>
          </h2>
          <p className="text-muted-foreground font-light leading-relaxed max-w-md">
            Rest Assured Group Travel LLC coordinates hotel and venue room blocks nationwide across
            the United States — from your hometown to any destination your group has in mind. If it has
            rooms to fill, we can block it.
          </p>
          <div className="flex items-center gap-3 mt-8 text-primary">
            <MapPin className="w-5 h-5" />
            <span className="label-eyebrow">Serving all 50 states</span>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-2 sm:grid-cols-3">
            {SERVICE_AREAS.map((city, i) => (
              <motion.div
                key={city}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.06 }}
                className="group border-b border-r border-border px-4 py-7 md:py-8 flex items-center gap-3 hover:bg-muted transition-colors"
              >
                <span className="font-display text-primary/40 text-xl group-hover:text-primary transition-colors">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="font-display text-2xl md:text-3xl font-light">{city}</span>
              </motion.div>
            ))}
          </div>
          <p className="label-eyebrow text-muted-foreground mt-6">
            A few of the destinations we book · and countless more
          </p>
        </div>
      </div>
    </div>
  </section>
);
